import { SvgIcon } from './svg-icon';
import { SvgIconProps } from './svg-icon.types';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    height: 32,
    width: 144, // adjust based on logo proportions
    fill: 'currentColor',
    viewBox: '0 0 802.29 179.85', // match the new logo viewBox
};

export const SiteLogo = (componentProps: SvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path
                class="cls-1 fill"
                d="M 118.31,136.28 H 93.3 c -12.68,0 -23,-10.32 -23,-23 V 35.21 h -40 V 66.57 H 12.91 L 0,103.57 h 30.29 v 9.71 c 0,34.74 28.26,63 63,63 h 38.96 l -13.95,-40 z"
                id="path2 fill"
                style="fill" />

            <polygon
                class="cls-1 fill"
                points="198.13,151.01 180.25,99.72 137.89,99.72 137.92,99.79 113.59,99.79 113.59,136.79 150.82,136.79 176.24,209.72 218.79,209.72 237.79,159.19 255.57,209.72 297.25,209.72 335.6,99.72 293.24,99.72 276.33,148.21 259.27,99.72 217.43,99.72 "
                id="polygon6"
                transform="translate(-33.29,-33.22)"
                style="fill" />

            <path
                class="cls-1 fill"
                d="m 353.55,63.89 c -32.02,0 -57.98,25.96 -57.98,57.98 0,32.02 25.96,57.98 57.98,57.98 32.02,0 57.98,-25.96 57.98,-57.98 0,-32.02 -25.96,-57.98 -57.98,-57.98 z m 0,76.56 c -10.26,0 -18.59,-8.32 -18.59,-18.59 0,-10.27 8.32,-18.59 18.59,-18.59 10.27,0 18.59,8.32 18.59,18.59 0,10.27 -8.32,18.59 -18.59,18.59 z"
                id="path1"
                style="fill" />
            
            <path
                class="cls-1 fill"
                d="M 488.74,66.51 H 461.53 V 63 c 0,-12.68 10.32,-23 23,-23 h 13.46 L 511.94,0 h -27.41 c -34.74,0 -63,28.26 -63,63 v 113.44 h 40 v -72.93 h 14.3 z"
                id="path3"
                style="fill" />
                
            <path
                class="cls-1 fill"
                d="m 539.93,63.89 c -32.02,0 -57.98,25.96 -57.98,57.98 0,32.02 25.96,57.98 57.98,57.98 32.02,0 57.98,-25.96 57.98,-57.98 0,-32.02 -25.96,-57.98 -57.98,-57.98 z m 0,76.56 c -10.26,0 -18.59,-8.32 -18.59,-18.59 0,-10.27 8.32,-18.59 18.59,-18.59 10.27,0 18.59,8.32 18.59,18.59 0,10.27 -8.32,18.59 -18.59,18.59 z"
                id="path4"
                style="fill" />

            <path
                class="cls-1 fill"
                d="m 670,66.57 c 0,27.48 0,61.76 0,63.31 0,3.08 -1.28,6.15 -3.77,8.34 -4.61,4.05 -11.62,3.59 -15.66,-1.01 -1.85,-2.11 -2.76,-4.72 -2.76,-7.32 0,-1.83 0,-35.94 0,-63.31 h -39.9 v 58.19 c 0,37.58 26.45,54.7 51.03,54.7 24.58,0 50.97,-18.79 50.97,-54.7 V 66.58 h -39.9 z"
                id="path6"
                style="fill" />
            
            <path
                class="cls-1 fill"
                d="m 759.9,176.62 h -40 v -51.31 c 0,-33.87 27.55,-61.42 61.42,-61.42 h 20.97 v 40 h -20.97 c -11.81,0 -21.42,9.61 -21.42,21.42 z"
                id="path5"
                style="fill" />
            
            
            {/* Add all other <path> elements here from your new SVG */}
        </SvgIcon>
    );
};
